// extracted by mini-css-extract-plugin
export default {"cardsWrapper":"OrgStatsTab_cardsWrapper__Y0aL4","cards":"OrgStatsTab_cards__Jw+nK","card":"OrgStatsTab_card__HMVwA","cardHeader":"OrgStatsTab_cardHeader__OcawW"};